// JsFromRoutes CacheKey 1791c1610666d2c144d33228595772a5
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  ideas: /* #__PURE__ */ definePathHelper('get', '/:org_nano_id/highlights/ideas'),
  index: /* #__PURE__ */ definePathHelper('get', '/:org_nano_id/highlights'),
  create: /* #__PURE__ */ definePathHelper('post', '/:org_nano_id/highlights'),
  update: /* #__PURE__ */ definePathHelper('patch', '/:org_nano_id/highlights/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/:org_nano_id/highlights/:id'),
}
